import { render, staticRenderFns } from "./InvestmentCategoryVisualization.vue?vue&type=template&id=5c5f4b2c&scoped=true&"
import script from "./InvestmentCategoryVisualization.vue?vue&type=script&lang=js&"
export * from "./InvestmentCategoryVisualization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5f4b2c",
  null
  
)

export default component.exports